import { mobiClient } from '@/services/axiosConfig'
import {
  CheckStatusRequest,
  CheckStatusResponse,
  TanCreateRequest,
  TanCreateResponse,
  TanConfirmRequest,
  TanConfirmResponse,
  DanResponse,
  TanConfirmRequestV2,
  TanConfirmResponseV2
} from './types'

export const checkStatus = async (
  req: CheckStatusRequest
): Promise<CheckStatusResponse | undefined> => {
  try {
    const res = await mobiClient.post('/handsetdti/checkstatus', req)
    return res.data
  } catch (e: any) {
    console.error('checkStatus error:', e)
    return e.response?.data
  }
}

export const createTanHandset = async (
  req: TanCreateRequest
): Promise<TanCreateResponse | undefined> => {
  try {
    const res = await mobiClient.post('/handsetdti/tancreate', req)
    return res.data
  } catch (e: any) {
    console.error('createTan error:', e)
    return e.response?.data
  }
}

export const confirmTanHandset = async (
  req: TanConfirmRequest
): Promise<TanConfirmResponse | undefined> => {
  try {
    const res = await mobiClient.post('/handsetdti/tanconfirm', req)
    return res.data
  } catch (e: any) {
    console.error('confirmTan error:', e)
    return e.response?.data
  }
}

export const confirmTanHandsetV2 = async (
  req: TanConfirmRequestV2
): Promise<TanConfirmResponseV2 | undefined> => {
  try {
    const res = await mobiClient.post('/handsetdti/tanconfirmV2', req)
    return res.data
  } catch (e: any) {
    console.error('confirmTan error:', e)
    return e.response?.data
  }
}

export const getHandsetDti = async (
  id: string
): Promise<DanResponse | undefined> => {
  try {
    const res = await mobiClient.get('/handsetdti', {
      params: { id }
    })
    return res.data
  } catch (e: any) {
    console.error('getHandsetDti error:', e)
    return e.response?.data
  }
}
export const retryInsurance = async (): Promise<boolean | undefined> => {
  try {
    const res = await mobiClient.get('/handsetdti/retry')
    return res.data
  } catch (e: any) {
    console.error('retry social insurance error:', e)
    return e.response?.data
  }
}
